import {
  Component,
  Input,
  OnInit,
} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import {
  BgBomCategory,
  BgBomGroupedSubCategory,
  BgBomItem,
  BgBomModel,
  BgBomSubCategory,
  CombinedBgBomItem,
  ComparisonResult,
} from 'src/app/shared/models/bg.model';
import { AuthService } from 'src/app/shared/services/auth.service';
import { ExcelService } from 'src/app/shared/services/excel.service';
import { PdfService } from 'src/app/shared/services/pdf.service';
import { Tab } from 'src/app/shared/models/tab.model';
import { ProjectModel } from 'src/app/shared/models/projectModel';
import { NgbDropdownConfig, Placement } from '@ng-bootstrap/ng-bootstrap';
import { BackendApiService } from 'src/app/shared/services/backend-api.service';
import { Client } from 'src/app/shared/models/client';
import { ProjectNode } from 'src/app/shared/models/projectNode';
import { SelectionService } from 'src/app/shared/services/selection.service';
import { IconService } from 'src/app/shared/services/icon.service';
import { BreadcrumbsIconsEnum } from 'src/app/shared/enums/icons.enum';
import { MatSnackBar } from '@angular/material/snack-bar';


const jsonData = {};
// Function to convert JSON to BgBomModel instance
function convertToBgBomModel(data: any): BgBomModel {
  const bgBomModel = new BgBomModel();
  bgBomModel.id = data.id;
  bgBomModel.subDivision = data.subDivision;
  bgBomModel.modelName = data.modelName;
  bgBomModel.model3dId = data.model3dId;
  bgBomModel.apsPresentationViews = data.apsPresentationViews;
  bgBomModel.cdFileUrl = data.cdFileUrl;
  bgBomModel.sdFileUrl = data.sdFileUrl;
  bgBomModel.hasOptions = data.hasOptions;

  if (data.bgCategories) {
    bgBomModel.bgCategories = data.bgCategories.map((categoryData: any) => {
      const category = new BgBomCategory();
      category.name = categoryData.name;
      category.order = categoryData.order;
      category.option = categoryData.option;
      category.optionName = categoryData.optionName;
      category.applicableOptions = categoryData.applicableOptions;
      category.optionsAutoApply = categoryData.optionsAutoApply;
      category.hasLevelGroupingDisplay = categoryData.hasLevelGroupingDisplay;

      if (categoryData.bgGroupedSubCategories) {
        category.bgGroupedSubCategories = categoryData.bgGroupedSubCategories.map((groupData: any) => {
          const group = new BgBomGroupedSubCategory();
          group.name = groupData.name;

          if (groupData.bgSubCategories) {
            group.bgSubCategories = groupData.bgSubCategories.map((subCatData: any) => {
              const subCategory = new BgBomSubCategory();
              subCategory.name = subCatData.name;
              subCategory.path = subCatData.path;

              if (subCatData.combinedBgBomItems) {
                subCategory.bgBomItems = subCatData.combinedBgBomItems.map((itemData: any) => {
                  const item: CombinedBgBomItem = {
                    ...new BgBomItem(),
                    ...itemData
                  };
                  return item;
                });
              }

              return subCategory;
            });
          }
          return group;
        });
      }

      return category;
    });
  }

  return bgBomModel;
}

// Convert JSON to BgBomModel instance
const bgBomModelInstance = convertToBgBomModel(jsonData);
console.log(bgBomModelInstance);

@Component({
  selector: 'app-bom-table-comparison',
  templateUrl: './bom-table-comparison.component.html',
  styleUrls: ['./bom-table-comparison.component.scss']
})

export class BomTableComparisonComponent implements OnInit {
  public checkboxItems: any[] = [];
  comparisonFilter: string = 'All'; // Default value
  modelSearchText: string = '';
  filteredModels: ProjectModel[] = [];

  public showSidebar: boolean = true; // Variable to control sidebar visibility
  public showMenuSelection: boolean = true; // Variable to control menu selection visibility
  public selectedCategories: Set<string> = new Set(); // To store selected categories
  //List of  categories how checkbox
  public selectedModelsMessage: string = ''; // Message to show in the selection menu

  public data: BgBomCategory[] = []; // Replace with actual data
  public groupedData: any[] = [];
  public selectedComparisonResult: ComparisonResult | 'All' = 'All'; // For filtering
  public selectedCategory: string | 'All' = 'All';
  public selectedModels: ProjectModel[] = [];

  public client?: Client;
  public projectStructure?: Array<ProjectNode>;

  TableName: string = 'Comparative table of Bom';
  TableNameAbout: string = 'Bom About Table';

  sortedCategories: BgBomCategory[] = []; // Initialize as empty array instead of undefined

  @Input() model?: ProjectModel;
  displayedColumns: string[] = [];
  combinedQuantityKeys: string[] = [];
  items: any[] = []; // We'll not use this anymore
  keyMapping: { [simplifiedKey: string]: string } = {};

  tabs?: Array<Tab>;

  navigationStack: ProjectNode[] = [];
  currentLevelNodes: ProjectNode[] = [];
  showBackButton = false;
  selectedNodeForModelSelection: ProjectNode | null = null;

  constructor(
    private authService: AuthService,
    private excelService: ExcelService,
    private pdfService: PdfService,
    private bgModelService: BackendApiService,
    private selectionService: SelectionService,
    private iconService: IconService,
    private snackBar: MatSnackBar,
    config: NgbDropdownConfig,
    private activatedRoute: ActivatedRoute
  ) {
    this.client = this.authService.getClientDataStructure();
    this.projectStructure = this.client?.projectStructure;

    config.placement = 'bottom-end' as Placement;
  }

  ngOnInit() {
    this.data =
      bgBomModelInstance.bgCategories ?? []
    ;

    this.sortedCategories = this.data.sort((a, b) => (a.order ?? 0) - (b.order ?? 0));

    // Initialize with top level nodes
    this.currentLevelNodes = this.client?.projectStructure || [];
    this.updateDisplayNodes();

    // Check for query parameters with IDs for automatic comparison
    this.checkForAutoComparison();
  }

  updateDisplayNodes() {
    if (this.navigationStack.length === 0) {
      // Show top level nodes
      this.currentLevelNodes = this.client?.projectStructure || [];
    } else {
      // Show nodes from the current level
      const currentLevel = this.navigationStack[this.navigationStack.length - 1];
      this.currentLevelNodes = currentLevel.nodes || [];
    }
    this.showBackButton = this.navigationStack.length > 0;
  }

  filterModels() {
    if (!this.selectedNodeForModelSelection?.models) return;

    if (!this.modelSearchText) {
      this.filteredModels = this.selectedNodeForModelSelection.models;
      return;
    }

    const searchTerm = this.modelSearchText.toLowerCase().trim();
    this.filteredModels = this.selectedNodeForModelSelection.models.filter(model => {
      // Create a searchable string that combines all relevant properties
      const searchableText = [
        model.name,
        model.projectName,
        model.projectNumber
      ].filter(Boolean).join(' ').toLowerCase();

      // Check if the search term appears anywhere in the combined text
      return searchableText.includes(searchTerm);
    });
  }

  private scrollToTop() {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  }

  navigateToNode(node: ProjectNode) {
    if (node.nodes && node.nodes.length > 0) {
      // If node has children, navigate to that level
      this.navigationStack.push(node);
      this.updateDisplayNodes();
      this.scrollToTop();
    } else if (node.models && node.models.length > 0) {
      // If node has models, set it as the selected node for model selection
      this.selectedNodeForModelSelection = node;
      this.modelSearchText = ''; // Reset search when changing nodes
      this.filterModels(); // Initialize filtered models
      this.scrollToTop();
    }
  }

  navigateBack() {
    if (this.selectedNodeForModelSelection) {
      // If models are open, go back to types
      this.selectedNodeForModelSelection = null;
      this.scrollToTop();
    } else if (this.navigationStack.length > 0) {
      // If types are open, go back to regions
      this.navigationStack.pop();
      this.updateDisplayNodes();
      this.scrollToTop();
    }
  }

  handleModelSelection(node: ProjectNode) {
    if (node.models) {
      node.models.forEach(model => {
        if (!this.selectedModels.find(m => m.id === model.id)) {
          this.addModelToSelection(model);
        }
      });
    }
  }

  prepareTable() {
    // Define static columns
    this.displayedColumns = [
      'itemName',
      'size',
      'description',
      'modelQuantity',
      'modelQuantityDescription',
    ];

    const quantityKeysSet = new Set<string>();
    (this.data as BgBomCategory[])?.forEach((BgBomCategory) => {
      BgBomCategory?.bgGroupedSubCategories?.forEach((groupSubCategory) => {
        groupSubCategory?.bgSubCategories?.forEach((subCategory) => {
          subCategory.bgBomItems.forEach((item: CombinedBgBomItem) => {
            if (item.combinedQuantityToOrder) {
              Object.keys(item.combinedQuantityToOrder).forEach((originalKey: string) => {
                const parts = originalKey.split('_');
                const simplifiedKey = parts.slice(-2).join('_');
                quantityKeysSet.add(simplifiedKey);
                this.keyMapping[simplifiedKey] = originalKey;
              });
            }
          });
        });
      });
    });

    this.combinedQuantityKeys = Array.from(quantityKeysSet);

    // Add dynamic columns to displayed columns
    this.displayedColumns = this.displayedColumns.concat(
      this.combinedQuantityKeys
    );

    // Prepare grouped data for the template
    this.groupedData = this.data.map((category) => {
      return {
        name: category.name,
        bgGroupedSubCategories: category.bgGroupedSubCategories?.map(
          (groupedSubCategory: { bgSubCategories: BgBomSubCategory[] | undefined; name: string | undefined }) => {
            return {
              name: groupedSubCategory.name,
              bgSubCategories: groupedSubCategory?.bgSubCategories?.map(
                (subCategory) => {
                  return {
                    name: subCategory.name,
                    combinedBgBomItems: subCategory.bgBomItems,
                  };
                }
              ),
            };
          }
        ),
      };
    });
  }

  toggleSidebar() {
    this.showSidebar = !this.showSidebar;
  }

  // Check if all categories are selected
  isAllCategoriesSelected(): boolean {
    return this.selectedCategories.size === this.data.length;
  }

  onSelectAllCategories(event: Event): void {
    const checkbox = event.target as HTMLInputElement;

    if (checkbox.checked) {
      // Select all categories
      this.selectedCategories = new Set(this.data.map(category => category.name));
       //Set children checkbox items  true
      this.checkboxItems = this.data.map(category => { return { name: category.name, checked: true } });
    } else {
      // Deselect all categories
      this.selectedCategories.clear();
      //Set children checkbox items  false
      this.checkboxItems = this.data.map(category => { return { name: category.name, checked: false } });
    }

    this.applyFilters();
  }

  updateSelectionMessage() {
    if (this.selectedModels.length === 0) {
      this.selectedModelsMessage = 'Select models to compare';
    } else if (this.selectedModels.length === 1) {
      this.selectedModelsMessage = 'Select one more model to compare';
    } else if (this.selectedModels.length > 10) {
      this.selectedModelsMessage = 'Maximum 10 models can be compared';
    }
    else {
      this.selectedModelsMessage = '';
    }
  }

  onSelectCategory(event: Event): void {
    const checkbox = event.target as HTMLInputElement;
    const categoryName = checkbox.id;

    if (checkbox.checked) {
      this.selectedCategories.add(categoryName);
    } else {
      this.selectedCategories.delete(categoryName);
    }

    this.applyFilters();
  }

  applyFilters() {
    const comparisonFilter = (item: CombinedBgBomItem) =>
      this.selectedComparisonResult === 'All' ||
      item.comparisonResult === this.selectedComparisonResult ||
      (this.selectedComparisonResult === ComparisonResult.Mismatch && item.comparisonResult === ComparisonResult.Unique);

    const categoryFilter = (category: BgBomCategory) =>
      this.selectedCategories.has(category.name);

    const result = this.data
      .filter(categoryFilter)
      .map((category) => {
        const filteredGroupedSubCategories = category.bgGroupedSubCategories?.map((groupedSubCategory) => {
          const filteredSubCategories = groupedSubCategory.bgSubCategories?.map((subCategory) => {
            const filteredItems = subCategory.bgBomItems.filter(comparisonFilter);

            if (filteredItems.length > 0) {
              return {
                ...subCategory,
                combinedBgBomItems: filteredItems
              };
            } else {
              return null; // Remove subCategory if no items after filtering
            }
          }).filter(Boolean); // Remove null subCategories

          if (filteredSubCategories && filteredSubCategories.length > 0) {
            return {
              ...groupedSubCategory,
              bgSubCategories: filteredSubCategories
            };
          } else {
            return null; // Remove groupedSubCategory if no subCategories
          }
        }).filter(Boolean); // Remove null groupedSubCategories

        if (filteredGroupedSubCategories && filteredGroupedSubCategories.length > 0) {
          return {
            ...category,
            bgGroupedSubCategories: filteredGroupedSubCategories
          };
        } else {
          return null; // Remove category if no groupedSubCategories
        }
      }).filter(Boolean); // Remove null categories

    this.groupedData = result;
  }

  isFilterActive(): boolean {
    const isComparisonFilterActive = this.selectedComparisonResult === 'All';
    const isAnyCheckboxUnchecked = this.checkboxItems.some(item => !item.checked);
    return !isComparisonFilterActive || isAnyCheckboxUnchecked;
  }

  onComparisonFilterChange(event: Event): void {
    const selectedValue = (event.target as HTMLSelectElement).value as ComparisonResult | 'All';
    this.selectedComparisonResult = selectedValue;
    this.applyFilters();
  }

  onCategoryFilterChange(event: Event): void {
    const selectedValue = (event.target as HTMLSelectElement).value;
    this.selectedCategory = selectedValue;
    this.applyFilters();
  }

  toggleCheckbox(item: any) {
    // Toggle the checked state
    item.checked = !item.checked;

    const name = item.name;
    const checked = item.checked;

    if (name) {
      // Remove or add the category based on the checked state
      if (!checked) {
        this.selectedCategories.delete(name);
      } else {
        this.selectedCategories.add(name);
      }
      this.applyFilters();
    }
  }

  selectedTemplates: string[] = [];

  onCheckboxChange(template: string, event: Event) {
    const isChecked = (event.target as HTMLInputElement).checked;
    if (isChecked) {
      this.selectedTemplates.push(template);
    } else {
      const index = this.selectedTemplates.indexOf(template);
      if (index > -1) {
        this.selectedTemplates.splice(index, 1);
      }
    }
  }

  exportTo(type: 'excel' | 'pdf') {
    if (!this.model) return;

    this.showSnackBar('Download started');

    switch (type) {
      case 'excel':
        this.exportToExcel();
        break;
      case 'pdf':
        this.exportToPdf();
        break;
      default:
        throw new Error('Invalid export type');
    }
  }

  exportToExcel() {
    if (this.groupedData && this.model) {
      this.excelService.exportDynamicModelToExcel(
        this.TableName,
        this.groupedData,
        this.model,
        this.authService.getClientName()
      );
      this.showSnackBar('Download completed successfully');
    }
  }

  exportToPdf() {
    if (this.groupedData) {
      new Promise(() => {
        this.pdfService.exportModelToPdfComparsion(
          this.TableName,
          this.groupedData,
          this.model,
          this.authService.getClientName(),
          false
        );
        this.showSnackBar('Download completed successfully');
      });
    }
  }

  /**
   * Displays a snack bar notification
   * @param message The message to display
   * @param action Text for the action button
   * @param duration Duration in milliseconds
   */
  showSnackBar(message: string, action: string = 'Close', duration: number = 5000): void {
    this.snackBar.open(message, action, {
      duration: duration,
      horizontalPosition: 'center',
      verticalPosition: 'top',
      panelClass: ['snackbar']
    });
  }

  // Placeholder for the comparison method
  isCompareButtonDisabled(): boolean {
    //selectedModels more than 2 and less than 11
    var result = this.selectedModels.length < 2 || this.selectedModels.length > 10;

    return result;
  }

  clearSelectedModels() {
    this.selectedModels = [];
    // Clear the selection in the service
    this.selectionService.setSelectedModels([]);
    this.projectStructure = this.client?.projectStructure;
    this.updateSelectionMessage();
  }

  comparison() {
    if (this.isCompareButtonDisabled()) return;

    this.model = this.selectedModels[0];
    const modelIds = this.selectedModels.map((model) => model.id);

    this.bgModelService.GetCompareBomModels(modelIds).subscribe({
      next: (result) => {
        if (result.isSuccess && result.result) {
          // Update jsonData with backend response
          Object.assign(jsonData, result.result);

          const bgBomModelInstance = convertToBgBomModel(jsonData);
          this.data = bgBomModelInstance.bgCategories ?? [];

          // Reset selected categories after new data
          this.selectedCategories = new Set(this.data.map(category => category.name));
          //Add checkbox items by default true
          this.checkboxItems = this.data.map(category => { return { name: category.name, checked: true } });
          this.showMenuSelection = false;

          this.prepareTable(); // Update table with new data
        } else {
          console.error('Comparison failed:', result.messages);
        }
      },
      error: (error) => {
        console.error('Error during comparison:', error);
      },
    });
  }

  isMenuSeletionsVisible(): boolean {
    return this.showMenuSelection;
  }

  addModelToSelection(model: ProjectModel): void {
    if (!this.selectedModels.some(m => m.id === model.id)) {
      this.selectedModels.push(model);
      this.updateSelectionMessage();
    }
  }

  removeModelFromSelection(model: ProjectModel): void {
    this.selectedModels = this.selectedModels.filter(m => m.id !== model.id);
    this.updateSelectionMessage();
  }

  getIcon(name: keyof typeof BreadcrumbsIconsEnum) {
    return this.iconService.getBreadcrumbsIconByName(name);
  }

  isModelSelected(model: ProjectModel): boolean {
    return this.selectedModels.some(m => m.id === model.id);
  }

  toggleModelSelection(model: ProjectModel, selected: boolean): void {
    if (selected) {
      this.addModelToSelection(model);
    } else {
      this.removeModelFromSelection(model);
    }
  }

  /**
   * Check if query parameters contain model IDs for automatic comparison
   */
  private checkForAutoComparison(): void {
    this.activatedRoute.queryParams.subscribe(params => {
      const ids = params['ids'];
      if (ids) {
        // Parse IDs from query parameter (expecting comma-separated string)
        const modelIds = typeof ids === 'string' ? ids.split(',').map(id => id.trim()) : [ids];
        if (modelIds.length >= 2) {
          this.loadModelsAndRunComparison(modelIds);
        }
      }
    });
  }

  /**
   * Find models by their IDs in the project structure and run automatic comparison
   */
  private loadModelsAndRunComparison(modelIds: string[]): void {
    const foundModels: ProjectModel[] = [];

    // Search through the entire project structure to find models by ID
    this.findModelsByIds(this.client?.projectStructure || [], modelIds, foundModels);

       // Add found models to selection
      this.selectedModels = foundModels;
      this.updateSelectionMessage();

      // Automatically run comparison
      this.runAutoComparison(modelIds);

  }

  /**
   * Recursively search for models by their IDs in the project structure
   */
  private findModelsByIds(nodes: ProjectNode[], targetIds: string[], foundModels: ProjectModel[]): void {
    for (const node of nodes) {
      // Check models in current node
      if (node.models) {
        for (const model of node.models) {
          if (targetIds.includes(model.id)) {
            foundModels.push(model);
          }
        }
      }

      // Recursively search child nodes
      if (node.nodes && node.nodes.length > 0) {
        this.findModelsByIds(node.nodes, targetIds, foundModels);
      }
    }
  }

  /**
   * Run automatic comparison without showing the selection menu
   */
  private runAutoComparison(modelId :string[] ): void {
    if (this.selectedModels.length < 2) {
      console.warn('Not enough models selected for automatic comparison');
      return;
    }

    this.model = this.selectedModels[0];
    const modelIds = modelId;

    this.bgModelService.GetCompareBomModels(modelIds).subscribe({
      next: (result) => {
        if (result.isSuccess && result.result) {
          // Update jsonData with backend response
          Object.assign(jsonData, result.result);

          const bgBomModelInstance = convertToBgBomModel(jsonData);
          this.data = bgBomModelInstance.bgCategories ?? [];

          // Reset selected categories after new data
          this.selectedCategories = new Set(this.data.map(category => category.name));
          // Add checkbox items by default true
          this.checkboxItems = this.data.map(category => { return { name: category.name, checked: true } });

          // Hide the selection menu and go directly to comparison view
          this.showMenuSelection = false;

          this.prepareTable(); // Update table with new data

          // Show success message
          this.showSnackBar(`Comparison loaded successfully for ${this.selectedModels.length} models`, 'Close', 5000);
        } else {
          console.error('Automatic comparison failed:', result.messages);
          this.showSnackBar('Comparison failed. Please try again manually.', 'Close', 8000);
        }
      },
      error: (error) => {
        console.error('Error during automatic comparison:', error);
        this.showSnackBar('Error loading comparison. Please try again manually.', 'Close', 8000);
      },
    });
  }
}








